import React, { useRef, useState } from 'react'
import './Todayfeedlist.css'
import date from "../../imgs/date.png";
import view from "../../imgs/view.png";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Viewprofile from '../Viewprofile/Viewprofile';


const Todayfeedlist = () => {
    const [input, setInput] = useState({ date1: "", date2: "" });
    const [loading, setLoading] = useState(false);
    const [DataSource, setDataSource] = useState([]);
    const navigate = useNavigate();
    const refprofile = useRef(null);
    const refprofileclose = useRef(null);
    const [contactdata, setContactdata] = useState({ mobno: "****************", amobno: "********************************", address: "********************************" });
    const [showconfirm, setShowconfirm] = useState(false);
    const [showfeed, setShowfeed] = useState(false);
    const [DataSourcepr, setDataSourcepr] = useState([]);
    const [path, setPath] = useState("photo");
    const [exist, setExist] = useState("");

    const handlephoto = () => {
        if (path === "photo") {
            setPath("photo2")
        }
        else if (path === "photo2") {
            setPath("photo3")
        }
        else if (path === "photo3") {
            setPath("photo")
        }

    }

    const sendtomadhysti = () => {

    }

    const confirmcontact = () => {


    }

    const showcontacts = () => {
        {
            DataSourcepr.map((user, index) => (
                setContactdata({ mobno: user.mobno, amobno: user.amobno, address: user.address })
            ))
        }

    }

    const closefeed = () => {
        setShowfeed(false);
      }

    const handleChange = (event) => {
        const name = event.target.name;
        const valuecurrent = event.target.value;

        setInput(value => ({ ...value, [name]: valuecurrent }))
    }


    const getaccountdata = (srrr) => {
        let rawData = {
          sr: srrr,
          rootsr: localStorage.getItem("sr"),
          veri: "-",
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)
    
        axios.post('https://softtesting.in/php/cust/getaccountdataweb.php', formData, {
          'Content-Type': 'multipart/form-data',
    
        }).then(function sample(response) {
          setDataSourcepr(response.data);
          refprofile.current.click();
    
        }).catch(err => {
          console.log(err);
        });
      }

    const openprofile = (srr) => {
        getaccountdata(srr);
    }

    const clearcontact = () => {
        refprofileclose.current.click();
        setContactdata({ mobno: "****************", amobno: "********************************", address: "********************************" });
        setShowconfirm(false);
        closefeed();
    }

    const gettodayfeedback = () => {
        setDataSource([]);
        let rawData = {
            brsr: localStorage.getItem("brno"),
            fdate: input.date1,
            tdate: input.date2,

        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://softtesting.in/php/cust/gettodayfeedbackweb.php', formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {
            console.log("todayfeed- ", response.data);
            setDataSource(response.data);

        }).catch(err => {
            console.log(err);
        });
    }


    return (
        <>
            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden="{true}"
                ref={refprofile}
                data-bs-target="#exampleModaldelete"
            >
            </button>

            <div className="modal fade" id="exampleModaldelete" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: '80vw' }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>

                            <button type="button" className="btn-close" onClick={clearcontact} data-bs-dismiss="modal" ref={refprofileclose} aria-label="Close">
                            </button>
                        </div>
                        <div className="modal-body">
                            <Viewprofile DataSource={DataSource} DataSourcepr={DataSourcepr} handlephoto={handlephoto} path={path} contactdata={contactdata} showconfirm={showconfirm} showcontacts={showcontacts} exist={exist} sendtomadhysti={sendtomadhysti} confirmcontact={confirmcontact} user={"feedback"} showfeed={showfeed} setShowfeed={setShowfeed} />
                        </div>
                    </div>
                </div>
            </div>
            <div className='todaymain'>
                <div className="todaymainback">
                    <span className="regularbold">Today's Feedback List</span>

                    <div className="rowtoday">
                        <img className='smalllogo3' src={date} alt="" />
                        <input className="form-control search2" type="date" id="date1" name="date1" onChange={handleChange} placeholder='Select From Date' />
                        <span className="too">To</span>
                        <img className='smalllogo3' src={date} alt="" />
                        <input className="form-control search2" type="date" id="date2" name="date2" onChange={handleChange} placeholder='Select From Date' />

                        <div onClick={gettodayfeedback} className="buttontoday">
                            <span className="regularboldregi">{loading ? "Please Wait.." : "Show"}</span>
                        </div>
                    </div>

                    <div className="midtoday">

                        <table id="table-to-xls" className="table table-striped">
                            <thead>
                                <tr>
                                    <th className='regularbold' scope="col">Sr</th>
                                    <th className='regularbold' scope="col">Customer</th>
                                    <th className='regularbold' scope="col">Date</th>
                                    <th className='regularbold' scope="col">Action</th>

                                </tr>
                            </thead>
                            <tbody>
                                {DataSource && DataSource.length > 0 && DataSource.map((user, index) =>
                                    <tr key={index + 1}>
                                        <td className={'regularbold'}>{index + 1}</td>
                                        <td className={'regularbold'}>{user.name}</td>
                                        <td className={'regularbold'}>{user.nextdate}</td>
                                        <td className={'regularbold'}><img onClick={() => openprofile(user.usersr)} className='viewlogo' src={view} alt="" /></td>



                                    </tr>
                                )}

                            </tbody>
                        </table>


                    </div>


                </div>
            </div>
        </>
    )
}

export default Todayfeedlist
